// NOTE: Allow auth using apikey (for email reasons)
export const HEADER_API_KEY = 'X-API-KEY';

// NOTE: Set market-request to ensure the market-response
export const HEADER_MARKET = 'X-MARKET';

// NOTE: Set locale-request to expect a locale-response
export const HEADER_LOCALE = 'X-LOCALE';
